import { contentRepositoryImplementation } from '@shared/infrastructure/http/repositories/content/contentRepositoryImplementation';
import { Content, ContentKind } from './content.aggregate';

export interface ContentRepository {
  getContents: (
    countryCode: string,
    languageCode: string
  ) => Promise<Content[]>;
  updateContent: (
    countryCode: string,
    languageCode: string,
    data: Content
  ) => Promise<void>;
  createContent: (
    countryCode: string,
    languageCode: string,
    data: Content
  ) => Promise<void>;
  deleteContent: (countryCode: string, contentId: number) => Promise<void>;
  uploadFile: (
    contentId: number,
    countryCode: string,
    body: any,
    fileType: ContentKind
  ) => Promise<void>;
}

export const contentRepository: ContentRepository = {
  getContents: (countryCode, languageCode) => {
    return contentRepositoryImplementation.getContents(
      countryCode,
      languageCode
    );
  },
  updateContent: (countryCode, languageCode, data) => {
    return contentRepositoryImplementation.updateContent(
      countryCode,
      languageCode,
      data
    );
  },
  createContent: (countryCode, languageCode, data) => {
    return contentRepositoryImplementation.createContent(
      countryCode,
      languageCode,
      data
    );
  },
  deleteContent: (countryCode, contentId) => {
    return contentRepositoryImplementation.deleteContent(
      countryCode,
      contentId
    );
  },
  uploadFile: (
    contentId: number,
    countryCode: string,
    body: any,
    fileType: ContentKind
  ) => {
    return contentRepositoryImplementation.uploadFile(
      contentId,
      countryCode,
      body,
      fileType
    );
  }
};
